<template>
  <div class="add-row-container">
    <el-button
      @click="$emit('addRow')"
      class="add-row"
      icon="el-icon-plus"
      size="mini"
      type="success"
      circle
    />
  </div>
</template>

<script>
  export default {};
</script>

<style>
  .add-row-container {
    text-align: center;
    margin: 10px 0;
  }

  .add-row-box {
    padding: 10px 20px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    cursor: pointer;
    text-align: center;
    width: 70px;
  }

  .add-row-box + .add-row-box {
    margin-left: 10px;
  }

  .add-row-box:hover {
    color: #409EFF;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
</style>